"use strict";
export default function noop() {
  return null;
}
